<template>
  <b-modal id="cancel-contract-modal" ref="modal" name="cancel" centered hide-footer hide-header>
    <center><h3><strong>{{ $t('LOAN_CANCEL_REASON') }}</strong></h3></center>
    <center>
      <select-input
        class="select"
        v-model="rejectReason"
        :items="reasons"
        :placeholder="$t('SELECT_ONE')"
      />
    </center>
    <div class="controls">
      <primary-button @click="close" blue :text="$t('BACK')" />
      <primary-button @click="save" :disabled="rejectReason === ''" :text="$t('REJECT')" />
    </div>
  </b-modal>
</template>

<script>
import { watch, ref, computed } from '@vue/composition-api';
import PrimaryButton from '@/components/PrimaryButton';

import { ORDER_STAGE } from '@/consts';

import SelectInput from '@/components/SelectInput';

export default {
  name: 'CancelDialog',
  components: {
    PrimaryButton,
    SelectInput
  },
  props: {
    contractId: Number,
    contractMifosId: Number,
    orderId: Number,
    value: {
      type: Boolean,
      default: false
    },
  },
  setup(props, { root, emit }) {
    const rejectReason = ref('');
    const modal = ref(null);

    const reasons = [
      { text: root.$t('FRAUD'), value: ORDER_STAGE.FRAUD.val },
      { text: root.$t('NOT_ELIGIBLE'), value: ORDER_STAGE.NOT_ELIGIBLE.val },
      { text: root.$t('RATE_DISAGREEMENT'), value: ORDER_STAGE.RATE_DISAGREEMENT.val },
      { text: root.$t('TERMS_DISAGREEMENT'), value: ORDER_STAGE.TERMS_DISAGREEMENT.val },
    ];

    const close = () => {
      emit('input', false);
      rejectReason.value = '';
    };

    const save = async () => {
      emit('reject', { reason: rejectReason.value });
      close();
    };

    const popup = computed(() => props.value);
    watch(popup, (value) => {
      if (value) {
        modal.value.show();
      } else {
        modal.value.hide();
      }
    });

    return {
      modal,
      rejectReason,
      reasons,
      close,
      save,
    };
  },
};
</script>

<style lang="scss">
#cancel-contract-modal {
  .modal-body {
    padding: 30px 15px;
  }

  h3 {
    margin-bottom: 20px;
  }

  .select {
    min-width: 300px;
  }

  .controls {
    margin-top: 20px;
    text-align: right;

    .primary-button {
      margin-left: 15px;
      border-radius: 4px;
    }
  }
}
</style>
